/**
 * Created by ronak-jain on 10/10/18.
 */
import hindi from './hindi'
import english from './english'

const language = {
  hindi: hindi,
  english: english
}

export const languages = {
  hindi: 'हिंदी',
  english: 'English'
}

export default language


// WEBPACK FOOTER //
// ./src/constants/languages.js